import { render, staticRenderFns } from "./SvgSignup.vue?vue&type=template&id=aa697aa4&scoped=true"
import script from "./SvgSignup.vue?vue&type=script&lang=ts"
export * from "./SvgSignup.vue?vue&type=script&lang=ts"
import style0 from "./SvgSignup.vue?vue&type=style&index=0&id=aa697aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa697aa4",
  null
  
)

export default component.exports